import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { QueryCase, Settings } from "./enums";

const SUCCESS_CONDITIONS = [QueryCase.Success, QueryCase.Empty];

const AxiosRequest = async (method, route, body = null) => {
    try {
        const response = await axios({ method, url: route, data: body });
        AxiosLog(response);
        return response.data;
    } catch (error) {
        AxiosLog(error?.response ?? error);
        throw error;
    }
};

export function SetupAxiosDefaults({ baseURL, apiKey, token }) {
    axios.defaults.baseURL = baseURL;
    axios.defaults.headers.common["x-functions-key"] = apiKey;
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
}

export function AxiosLog(response) {
    if (!Settings.AxiosLogs || !response) {
        return;
    }

    const config = response.config ?? {};
    const data = response.data ?? {};

    console.log({
        message: response.message,
        name: response.name,
        url: config.baseURL && config.url ? config.baseURL + config.url : config.url,
        method: config.method,
        code: response.code,
        status: response.status,
        statusText: response.statusText,
        data: {
            condition: data.condition,
            data: data.data,
            details: data.details,
            isDataCompressed: data.isDataCompressed,
            reflection: data.reflection ? data.reflection : config.data && (config.data.startsWith("{") || config.data.startsWith("[")) ? JSON.parse(config.data) : config.data
        }
    });
}

const toQueryKey = (queryId, body) => [queryId, body ?? null];

export function GetData(queryId, body = null, enabled = true, retry = 1) {
    const response = useQuery({
        queryKey: toQueryKey(queryId, body),
        queryFn: () => AxiosRequest(body ? "post" : "get", queryId, body),
        retry,
        refetchOnWindowFocus: false,
        enabled
    });

    const condition = response.data?.condition ?? QueryCase.Unknown;
    const resultData = response.data?.data ?? null;
    const isLoading = response.isLoading || response.isFetching || response.isRefetching;

    return {
        isLoading,
        data: resultData,
        condition,
        isFalse: isLoading || response.isError || response.isLoadingError || response.isRefetchError || !SUCCESS_CONDITIONS.includes(condition),
        isEmpty: condition === QueryCase.Empty || resultData === null || resultData === undefined || (Array.isArray(resultData) && resultData.length === 0),
        refetch: response.refetch
    };
}

export const MutateData = (queryId, onEnd = null, onCases = null, method = "post") => {
    return useMutation({
        mutationKey: [queryId],
        mutationFn: (variables) => AxiosRequest(variables ? method : "get", queryId, variables),
        onSuccess: (data) => {
            if (onEnd) {
                onEnd(data);
            }

            let noCase = true;
            onCases?.forEach((item) => {
                if (item.case === data?.condition) {
                    noCase = false;
                    item.onCase(data);
                }
            });

            if (noCase) {
                onCases?.find((item) => item.case === QueryCase.Error)?.onCase();
            }
        },
        onError: () => {
            if (onEnd) {
                onEnd();
            }
            onCases?.find((item) => item.case === QueryCase.Error)?.onCase();
        },
        retry: 0
    });
};
